import { IAppEnum } from "../enum/app.enum";
import { ITeamAnalyticsActivityEnum, ITeamAnalyticsActivityV2Enum } from "../enum/team-analytics-activity/team-analytics-activity.enum";

export interface TeamAppMetricsDto {
  totalTimeInApp: {
    value: number;
    percentChange: number;
  };
  totalInteractions: {
    value: number;
    percentChange: number;
  };
  averageInteractionDuration: {
    value: number;
    percentChange: number;
  };
  averageInteractionsPerPerson: {
    value: number;
    percentChange: number;
  };
  averageTimeInAppPerPerson: {
    value: number;
    percentChange: number;
  };
  historicAverageDuration: number;
  historicAverageInteractions: number;
  historicAverageInteractionDuration: number;
  historicMaxDuration: number;
  historicMaxInteractions: number;
  historicMaxAvgInteractionDuration: number;
  weekdayAverageDuration: number;
  weekdayAverageInteractions: number;
  weekdayAverageInteractionDuration: number;
}

export interface LatestTeamAppMetricsRaw { 
  [ITeamAnalyticsActivityEnum.LocalStartTimeWeek]: string, 
  [ITeamAnalyticsActivityEnum.LocalStartTime]: string, 
  [ITeamAnalyticsActivityEnum.TotalDuration]: string, 
  [ITeamAnalyticsActivityEnum.Count]: string,
  [ITeamAnalyticsActivityEnum.AverageInteractionDuration]: string,
  [ITeamAnalyticsActivityEnum.PerUserAvgDuration]: string,
  [ITeamAnalyticsActivityEnum.PerUserAvgCount]: string  
}

export interface LatestTeamAppMetricsV2Raw { 
  [ITeamAnalyticsActivityV2Enum.LocalStartTimeWeek]: string, 
  [ITeamAnalyticsActivityV2Enum.LocalStartTime]: string, 
  [ITeamAnalyticsActivityV2Enum.TotalDuration]: string, 
  [ITeamAnalyticsActivityV2Enum.Count]: string,
  [ITeamAnalyticsActivityV2Enum.AverageInteractionDuration]: string,
  [ITeamAnalyticsActivityV2Enum.PerUserAvgDuration]: string,
  [ITeamAnalyticsActivityV2Enum.PerUserAvgCount]: string  
}

export interface LatestTeamAppMetricsResult {
  totalTimeInApp: number;
  totalInteractions: number;
  averageInteractionDuration: number;
  averageTimeInAppPerPerson: number;
  averageInteractionsPerPerson: number;
}

export interface AllTimeAverageTeamAppMetricsResult {
  averageDuration: number;
  averageInteractions: number;
  averageInteractionDuration: number;
  averageTimeInAppPerPerson: number;
  averageInteractionsPerPerson: number;
}

export interface AllTimeAverageTeamAppMetricsRaw { 
  [ITeamAnalyticsActivityEnum.AverageInteractionDuration]: string, 
  [ITeamAnalyticsActivityEnum.AverageDailyDuration]: string, 
  [ITeamAnalyticsActivityEnum.AverageDailyInteractions]: string, 
  [ITeamAnalyticsActivityEnum.PerUserAvgDailyDuration]: string,
  [ITeamAnalyticsActivityEnum.PerUserAvgDailyInteractions]: string,
}

export interface AllTimeAverageTeamAppMetricsV2Raw { 
  [ITeamAnalyticsActivityV2Enum.AverageInteractionDuration]: string, 
  [ITeamAnalyticsActivityV2Enum.AverageDailyDuration]: string, 
  [ITeamAnalyticsActivityV2Enum.AverageDailyInteractions]: string, 
  [ITeamAnalyticsActivityV2Enum.PerUserAvgDailyDuration]: string,
  [ITeamAnalyticsActivityV2Enum.PerUserAvgDailyInteractions]: string,
}

export interface AllTimeWeekdayAverageTeamAppMetricsResult {
  weekdayAverageDuration: number;
  weekdayAverageInteractions: number;
  weekdayAverageInteractionDuration: number;
  averageTimeInAppPerPerson: number;
  averageInteractionsPerPerson: number;
}

export interface AllTimeSeriesTeamAppMetricsRaw {
  [ITeamAnalyticsActivityEnum.AverageDailyDuration]: string,
  [ITeamAnalyticsActivityEnum.AverageDailyInteractions]: string,
  [ITeamAnalyticsActivityEnum.AverageInteractionDuration]: string
}

export interface AllTimeSeriesTeamAppMetricsV2Raw {
  [ITeamAnalyticsActivityV2Enum.AverageDailyDuration]: string,
  [ITeamAnalyticsActivityV2Enum.AverageDailyInteractions]: string,
  [ITeamAnalyticsActivityV2Enum.AverageInteractionDuration]: string
}

export interface UserTimeSeriesAppMetricsRaw {
  [ITeamAnalyticsActivityEnum.UserId]: string,
  [ITeamAnalyticsActivityEnum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityEnum.LocalStartTime]: string,
  [ITeamAnalyticsActivityEnum.TotalDuration]: string,
  [ITeamAnalyticsActivityEnum.Count]: string,
  [ITeamAnalyticsActivityEnum.AverageInteractionDuration]: string
}

export interface UserTimeSeriesAppMetricsV2Raw {
  [ITeamAnalyticsActivityV2Enum.UserId]: string,
  [ITeamAnalyticsActivityV2Enum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityV2Enum.LocalStartTime]: string,
  [ITeamAnalyticsActivityV2Enum.TotalDuration]: string,
  [ITeamAnalyticsActivityV2Enum.Count]: string,
  [ITeamAnalyticsActivityV2Enum.AverageInteractionDuration]: string
}

export interface TeamAverageTimeSeriesAppMetricsRaw {
  [ITeamAnalyticsActivityEnum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityEnum.LocalStartTime]: string,
  [ITeamAnalyticsActivityEnum.PerUserAvgDuration]: string,
  [ITeamAnalyticsActivityEnum.PerUserAvgCount]: string,
  [ITeamAnalyticsActivityEnum.AverageInteractionDuration]: string
}

export interface TeamAverageTimeSeriesAppMetricsV2Raw {
  [ITeamAnalyticsActivityV2Enum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityV2Enum.LocalStartTime]: string,
  [ITeamAnalyticsActivityV2Enum.PerUserAvgDuration]: string,
  [ITeamAnalyticsActivityV2Enum.PerUserAvgCount]: string,
  [ITeamAnalyticsActivityV2Enum.AverageInteractionDuration]: string
}

export interface TeamTimeSeriesAppMetricsRaw {
  [ITeamAnalyticsActivityEnum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityEnum.LocalStartTime]: string,
  [ITeamAnalyticsActivityEnum.TotalDuration]: string,
  [ITeamAnalyticsActivityEnum.Count]: string,
  [ITeamAnalyticsActivityEnum.AverageInteractionDuration]: string
}

export interface TeamTimeSeriesAppMetricsV2Raw {
  [ITeamAnalyticsActivityV2Enum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityV2Enum.LocalStartTime]: string,
  [ITeamAnalyticsActivityV2Enum.TotalDuration]: string,
  [ITeamAnalyticsActivityV2Enum.Count]: string,
  [ITeamAnalyticsActivityV2Enum.AverageInteractionDuration]: string
}

export interface LatestFilteredTeamSubscriptionMetricsItemRaw {
  [ITeamAnalyticsActivityEnum.AppId]: string,
  [ITeamAnalyticsActivityEnum.SubscriptionId]: string,
  [ITeamAnalyticsActivityEnum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityEnum.LocalStartTime]: string,
  [ITeamAnalyticsActivityEnum.TotalDuration]: string,
  [ITeamAnalyticsActivityEnum.Count]: string
}

export interface LatestFilteredTeamSubscriptionMetricsItemV2Raw {
  [ITeamAnalyticsActivityV2Enum.AppId]: string,
  [ITeamAnalyticsActivityV2Enum.SubscriptionId]: string,
  [ITeamAnalyticsActivityV2Enum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityV2Enum.LocalStartTime]: string,
  [ITeamAnalyticsActivityV2Enum.TotalDuration]: string,
  [ITeamAnalyticsActivityV2Enum.Count]: string
}

export interface UserCountRaw {
  [ITeamAnalyticsActivityEnum.AppId]: string,
  [ITeamAnalyticsActivityEnum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityEnum.LocalStartTime]: string,
  [ITeamAnalyticsActivityEnum.UserCount]: string,
}

export interface UserCountV2Raw {
  [ITeamAnalyticsActivityV2Enum.AppId]: string,
  [ITeamAnalyticsActivityV2Enum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityV2Enum.LocalStartTime]: string,
  [ITeamAnalyticsActivityV2Enum.UserCount]: string,
}

export interface LatestFilteredTeamAppMetricsItemRaw {
  [ITeamAnalyticsActivityEnum.AppId]: string,
  [IAppEnum.Name]: string,
  [IAppEnum.LogoUrl]: string,
  [IAppEnum.DisplayColor]: string,
  [ITeamAnalyticsActivityEnum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityEnum.LocalStartTime]: string,
  [ITeamAnalyticsActivityEnum.TotalDuration]: string,
  [ITeamAnalyticsActivityEnum.Count]: string
}

export interface LatestFilteredTeamAppMetricsItemV2Raw {
  [ITeamAnalyticsActivityV2Enum.AppId]: string,
  [ITeamAnalyticsActivityV2Enum.LocalStartTimeDay]: string,
  [ITeamAnalyticsActivityV2Enum.LocalStartTime]: string,
  [ITeamAnalyticsActivityV2Enum.TotalDuration]: string,
  [ITeamAnalyticsActivityV2Enum.Count]: string
}

export interface TeamTotalMetricsRaw {
  [ITeamAnalyticsActivityEnum.PerUserAvgDuration]: string,
  [ITeamAnalyticsActivityEnum.PerUserAvgCount]: string,
  [ITeamAnalyticsActivityEnum.TotalDuration]: string,
  [ITeamAnalyticsActivityEnum.Count]: string
}

export interface TeamTotalMetricsV2Raw {
  [ITeamAnalyticsActivityV2Enum.PerUserAvgDuration]: string,
  [ITeamAnalyticsActivityV2Enum.PerUserAvgCount]: string,
  [ITeamAnalyticsActivityV2Enum.TotalDuration]: string,
  [ITeamAnalyticsActivityV2Enum.Count]: string
}
